import * as React from "react";
import { IconProps } from "./IconProps";

export const IconFilterSort2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          id="Icon (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.333336 1.33329C0.333336 0.965103 0.631813 0.666626 1 0.666626H13C13.3682 0.666626 13.6667 0.965103 13.6667 1.33329C13.6667 1.70148 13.3682 1.99996 13 1.99996H1C0.631813 1.99996 0.333336 1.70148 0.333336 1.33329ZM2.33334 5.99996C2.33334 5.63177 2.63181 5.33329 3 5.33329H11C11.3682 5.33329 11.6667 5.63177 11.6667 5.99996C11.6667 6.36815 11.3682 6.66663 11 6.66663H3C2.63181 6.66663 2.33334 6.36815 2.33334 5.99996ZM4.33334 10.6666C4.33334 10.2984 4.63181 9.99996 5 9.99996H9C9.36819 9.99996 9.66667 10.2984 9.66667 10.6666C9.66667 11.0348 9.36819 11.3333 9 11.3333H5C4.63181 11.3333 4.33334 11.0348 4.33334 10.6666Z"
          fill={color}
        />
      </svg>
    );
  },
);
